import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=66c7fdac&scoped=true&lang=pug"
import script from "./versions.vue?vue&type=script&lang=js"
export * from "./versions.vue?vue&type=script&lang=js"
import style0 from "./versions.vue?vue&type=style&index=0&id=66c7fdac&prod&lang=scss&scoped=true"
import style1 from "./versions.vue?vue&type=style&index=1&id=66c7fdac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c7fdac",
  null
  
)

export default component.exports